import Quiz from '../../../api/Quiz';
import * as types from './mutation-types';

export const getQuiz = async ({ commit }, id) => {
    const json = await new Quiz().show(id);

    commit(types.QUIZ, json);
    commit(types.QUIZ_QUESTIONS, json.user_questions.map((question) => {
        return {
            id: question.id,
            answered: false,
        }
    }));
};

export const checkChoiceQuestion = async (context, id) => {
    return await new Quiz().checkChoiceQuestion(id);
};

export const checkPictureQuestion = async (context, { id, params }) => {
    return await new Quiz().checkPictureQuestion(id, params);
};

export const setResult = async (context, params) => {
    return await new Quiz().setResult(params);
};

export const startQuiz = async (context, params) => {
    await new Quiz().startQuiz(params);
};

export const getRightChoiseQuestionAnswer = async (context, {id}) => {
    return await new Quiz().getRightChoiseQuestionAnswer(id);
}

export const getRightPictureQuestionAnswer = async (context, {id}) => {
    return await new Quiz().getRightPictureQuestionAnswer(id);
}

export default {
    getQuiz,
    checkChoiceQuestion,
    setResult,
    startQuiz,
    checkPictureQuestion,
    getRightChoiseQuestionAnswer,
    getRightPictureQuestionAnswer,
};



// WEBPACK FOOTER //
// ./src/store/modules/quiz/actions.js